import React from "react";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const StyledToolbarContainer = styled(GridToolbarContainer)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
}));

export default function WaterServiceConnectionsToolbar({
  showPendingRecords,
  onShowPendingRecordsChange,
  onAddNewRecord,
}) {
  return (
    <StyledToolbarContainer>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={showPendingRecords}
              onChange={(e) => onShowPendingRecordsChange(e.target.checked)}
              sx={{ ml: 2 }}
            />
          }
          label="Show Denied Connections"
        />
      </Box>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={onAddNewRecord} color="secondary">
          Add Water Service Connection
        </Button>
      </Box>
    </StyledToolbarContainer>
  );
}
